/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* WebGL cursor-follow fill for the Reimagine landing header */
(function () {
    const revealAreas = document.querySelectorAll('[data-cursor-reveal]');

    if (!revealAreas.length) return;

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const liquidPalette = [
        0xff4ea4,
        0xff843a,
        0xffd348,
        0x43dc88,
        0x3ab2ff,
        0x8168ff
    ];

    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }

    function randomFrom(index, seed) {
        const value = Math.sin((index + 1) * 12.9898 + seed * 78.233) * 43758.5453;

        return value - Math.floor(value);
    }

    function mixAngle(current, target, amount) {
        const delta = Math.atan2(Math.sin(target - current), Math.cos(target - current));

        return current + delta * amount;
    }

    function createBlobTexture() {
        const size = 256;
        const canvas = document.createElement('canvas');

        canvas.width = size;
        canvas.height = size;

        const context = canvas.getContext('2d');
        const center = size / 2;
        const gradient = context.createRadialGradient(center, center, 0, center, center, center);

        gradient.addColorStop(0, 'rgba(255,255,255,1)');
        gradient.addColorStop(0.32, 'rgba(255,255,255,0.96)');
        gradient.addColorStop(0.62, 'rgba(255,255,255,0.46)');
        gradient.addColorStop(1, 'rgba(255,255,255,0)');
        context.fillStyle = gradient;
        context.fillRect(0, 0, size, size);

        return PIXI.Texture.from(canvas);
    }

    revealAreas.forEach(function (revealArea) {
        const fillTargets = revealArea.querySelectorAll('.gh-reimagine-title-word span');

        if (!fillTargets.length) return;
        if (!window.PIXI || !window.PIXI.Application || !window.PIXI.Text || prefersReducedMotion) return;

        const app = new PIXI.Application();
        const stage = new PIXI.Container();
        const paintLayer = new PIXI.Container();
        const blobTexture = createBlobTexture();
        const ambientBlobs = [];
        const cursorBlobs = [];
        const splashes = [];
        const pointer = {
            x: 0.5,
            y: 0.5,
            px: 0.5,
            py: 0.5,
            vx: 0,
            vy: 0,
            speed: 0,
            angle: 0,
            targetAngle: 0,
            strength: 0
        };

        let width = 1;
        let height = 1;
        let isActive = false;
        let releaseTimer = null;
        let phase = 0;
        let resizeTimer = null;
        let canvasElement = null;
        let outlineCanvasElement = null;
        let renderBleed = 0;

        function makeBlob(tint, alpha) {
            const sprite = new PIXI.Sprite(blobTexture);

            sprite.anchor.set(0.5);
            sprite.tint = tint;
            sprite.alpha = alpha;
            sprite.eventMode = 'none';
            sprite.blendMode = 'add';

            return sprite;
        }

        function getCanvasFont(computed) {
            return [
                computed.fontStyle,
                computed.fontVariant,
                computed.fontWeight,
                computed.fontSize,
                computed.fontFamily
            ].filter(function (part) {
                return part && part !== 'normal';
            }).join(' ');
        }

        function drawTextToCanvas(context, target, x, y, mode) {
            const computed = window.getComputedStyle(target);
            const fontSize = parseFloat(computed.fontSize) || 120;
            const strokeWidth = clamp(fontSize * 0.012, 1.2, 3.4);

            context.save();
            context.font = getCanvasFont(computed);
            context.textAlign = 'left';
            context.textBaseline = 'top';
            context.lineJoin = 'round';
            context.miterLimit = 2;
            if ('letterSpacing' in context) {
                context.letterSpacing = computed.letterSpacing;
            }
            if ('fontKerning' in context) {
                context.fontKerning = 'normal';
            }

            if (mode === 'mask') {
                context.fillStyle = '#fff';
                context.fillText(target.textContent || '', x, y);
            } else {
                context.lineWidth = strokeWidth;
                context.strokeStyle = 'rgba(255, 255, 255, 0.7)';
                context.fillStyle = 'rgba(255, 255, 255, 0.028)';
                context.strokeText(target.textContent || '', x, y);
                context.fillText(target.textContent || '', x, y);
            }

            context.restore();
        }

        function getRenderBleed() {
            const computed = window.getComputedStyle(fillTargets[0]);
            const fontSize = parseFloat(computed.fontSize) || 120;

            return clamp(fontSize * 0.18, 16, 76);
        }

        function positionRenderLayer(element) {
            if (!element) return;

            element.style.top = (-renderBleed).toFixed(2) + 'px';
            element.style.bottom = 'auto';
            element.style.height = height.toFixed(2) + 'px';
        }

        function syncTextTextures() {
            if (!canvasElement || !width || !height) return;

            const parentRect = revealArea.getBoundingClientRect();
            const resolution = Math.min(window.devicePixelRatio || 1, 1.5);
            const maskCanvas = document.createElement('canvas');
            const outlineCanvas = document.createElement('canvas');
            const maskContext = maskCanvas.getContext('2d');
            const outlineContext = outlineCanvas.getContext('2d');

            maskCanvas.width = Math.max(1, Math.ceil(width * resolution));
            maskCanvas.height = Math.max(1, Math.ceil(height * resolution));
            outlineCanvas.width = maskCanvas.width;
            outlineCanvas.height = maskCanvas.height;
            maskContext.scale(resolution, resolution);
            outlineContext.scale(resolution, resolution);

            fillTargets.forEach(function (target) {
                const rect = target.getBoundingClientRect();
                const x = rect.left - parentRect.left;
                const y = rect.top - parentRect.top + renderBleed;

                drawTextToCanvas(maskContext, target, x, y, 'mask');
                drawTextToCanvas(outlineContext, target, x, y, 'outline');
            });

            const mask = 'url("' + maskCanvas.toDataURL('image/png') + '")';

            canvasElement.style.webkitMaskImage = mask;
            canvasElement.style.maskImage = mask;

            if (!outlineCanvasElement) {
                outlineCanvasElement = document.createElement('canvas');
                outlineCanvasElement.className = 'gh-reimagine-outline-canvas';
                revealArea.appendChild(outlineCanvasElement);
            }

            positionRenderLayer(outlineCanvasElement);
            outlineCanvasElement.width = outlineCanvas.width;
            outlineCanvasElement.height = outlineCanvas.height;

            const visibleContext = outlineCanvasElement.getContext('2d');

            visibleContext.clearRect(0, 0, outlineCanvasElement.width, outlineCanvasElement.height);
            visibleContext.drawImage(outlineCanvas, 0, 0);
        }

        function seedBlobs() {
            const count = width < 700 ? 10 : 14;
            const minSide = Math.min(width, height);

            ambientBlobs.forEach(function (blob) {
                blob.sprite.destroy();
            });
            ambientBlobs.length = 0;

            for (let index = 0; index < count; index += 1) {
                const radius = clamp(minSide * (0.16 + randomFrom(index, 3) * 0.26), 48, 170);
                const sprite = makeBlob(liquidPalette[index % liquidPalette.length], 0.72 + randomFrom(index, 4) * 0.26);

                paintLayer.addChild(sprite);
                ambientBlobs.push({
                    sprite: sprite,
                    x: randomFrom(index, 1) * width,
                    y: (0.12 + randomFrom(index, 2) * 0.76) * height,
                    radius: radius,
                    drift: 0.11 + randomFrom(index, 5) * 0.28,
                    flowX: 18 + randomFrom(index, 6) * 46,
                    flowY: 12 + randomFrom(index, 7) * 34,
                    flowX2: 8 + randomFrom(index, 8) * 24,
                    flowY2: 10 + randomFrom(index, 9) * 26,
                    stretch: 1.08 + randomFrom(index, 10) * 0.42,
                    phase: randomFrom(index, 11) * Math.PI * 2
                });
            }
        }

        function setupCursorBlobs() {
            if (cursorBlobs.length) return;

            [
                { tint: 0xffffff, alpha: 1, radius: 0.38, trail: 0, side: 0, stretch: 1 },
                { tint: 0xff4ea4, alpha: 0.92, radius: 0.56, trail: 0.48, side: 0.2, stretch: 1.38, phase: 0.2 },
                { tint: 0xffd348, alpha: 0.88, radius: 0.52, trail: 0.76, side: -0.18, stretch: 1.34, phase: 1.7 },
                { tint: 0x3ab2ff, alpha: 0.9, radius: 0.58, trail: 0.34, side: -0.26, stretch: 1.46, phase: 3.2 },
                { tint: 0x43dc88, alpha: 0.8, radius: 0.64, trail: 0.92, side: 0.16, stretch: 1.5, phase: 4.6 }
            ].forEach(function (config) {
                const sprite = makeBlob(config.tint, 0);

                paintLayer.addChild(sprite);
                cursorBlobs.push(Object.assign({ sprite: sprite }, config));
            });
        }

        function addSplash(x, y, speed) {
            const count = speed > 70 ? 2 : 1;
            const length = Math.max(1, Math.hypot(pointer.vx * width, pointer.vy * height));
            const dirX = (pointer.vx * width) / length;
            const dirY = (pointer.vy * height) / length;
            const perpX = -dirY;
            const perpY = dirX;

            for (let index = 0; index < count; index += 1) {
                if (splashes.length > 18) {
                    const oldSplash = splashes.pop();

                    oldSplash.sprite.destroy();
                }

                const side = (randomFrom(splashes.length + index, 17) - 0.5) * clamp(speed * 0.45, 12, 44);
                const back = clamp(speed * (0.24 + randomFrom(splashes.length + index, 18) * 0.22), 10, 56);
                const sprite = makeBlob(liquidPalette[(splashes.length + Math.floor(phase * 11)) % liquidPalette.length], 0.78);

                paintLayer.addChild(sprite);
                splashes.unshift({
                    sprite: sprite,
                    x: x - dirX * back + perpX * side,
                    y: y - dirY * back + perpY * side,
                    vx: -dirX * clamp(speed * 0.014, 0.28, 1.4) + perpX * side * 0.006,
                    vy: -dirY * clamp(speed * 0.014, 0.28, 1.4) + perpY * side * 0.006,
                    radius: clamp(46 + speed * 0.24 + randomFrom(splashes.length + index, 19) * 34, 54, 152),
                    stretch: 1.16 + randomFrom(splashes.length + index, 20) * 0.7,
                    rotation: Math.atan2(dirY, dirX),
                    age: 0,
                    life: 34 + randomFrom(splashes.length + index, 21) * 18
                });
            }
        }

        function resize() {
            const rect = revealArea.getBoundingClientRect();

            width = Math.max(1, Math.round(rect.width));
            renderBleed = getRenderBleed();
            height = Math.max(1, Math.round(rect.height + renderBleed * 2));
            positionRenderLayer(canvasElement);
            if (app.renderer) {
                app.renderer.resize(width, height);
            }
            syncTextTextures();
            seedBlobs();
        }

        function scheduleResize() {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(resize, 80);
        }

        function scaleSprite(sprite, radius, stretch, rotation) {
            const size = radius * 2;

            sprite.width = size * (stretch || 1);
            sprite.height = size;
            sprite.rotation = rotation || 0;
        }

        function updateBlobPositions(ticker) {
            const delta = Math.min(ticker.deltaMS / 16.6667, 2.2);
            const cursorRadius = clamp(Math.min(width, height) * 0.23, 64, 150);
            const velocity = Math.hypot(pointer.vx * width, pointer.vy * height);
            const speedRatio = clamp((pointer.speed || velocity) / 180, 0, 1);

            if (velocity < 1.2 && pointer.strength > 0.04) {
                pointer.targetAngle += 0.0038 * delta;
            }

            pointer.angle = mixAngle(
                pointer.angle,
                pointer.targetAngle,
                1 - Math.pow(Math.max(0.66, 0.88 - speedRatio * 0.18), delta)
            );

            const directionX = Math.cos(pointer.angle);
            const directionY = Math.sin(pointer.angle);
            const perpendicularX = -directionY;
            const perpendicularY = directionX;

            phase += 0.01 * delta;
            pointer.strength += ((isActive ? 1 : 0) - pointer.strength) * 0.24;
            pointer.vx *= Math.pow(0.78, delta);
            pointer.vy *= Math.pow(0.78, delta);
            pointer.speed *= Math.pow(0.86, delta);

            ambientBlobs.forEach(function (blob, index) {
                const sprite = blob.sprite;
                const flow = phase * blob.drift + blob.phase;

                sprite.x = blob.x +
                    Math.sin(flow) * blob.flowX +
                    Math.sin(flow * 0.43 + index) * blob.flowX2;
                sprite.y = blob.y +
                    Math.cos(flow * 0.72) * blob.flowY +
                    Math.sin(flow * 0.31 + index * 1.7) * blob.flowY2;
                sprite.alpha = 0.58 + Math.sin(phase * 0.56 + index) * 0.08;
                scaleSprite(
                    sprite,
                    blob.radius * (1 + Math.sin(flow * 0.6) * 0.04),
                    blob.stretch,
                    Math.sin(flow * 0.32) * 0.3
                );
            });

            cursorBlobs.forEach(function (blob) {
                const wobble = Math.sin(phase * 3.8 + (blob.phase || 0));
                const trail = cursorRadius * blob.trail * (0.72 + speedRatio * 0.55);
                const side = cursorRadius * blob.side * wobble;
                const x = pointer.x * width - directionX * trail + perpendicularX * side;
                const y = pointer.y * height - directionY * trail + perpendicularY * side;

                blob.sprite.x = x;
                blob.sprite.y = y;
                blob.sprite.alpha = blob.alpha * pointer.strength * (0.86 + speedRatio * 0.18);
                scaleSprite(
                    blob.sprite,
                    cursorRadius * blob.radius * (1 + speedRatio * 0.14),
                    blob.stretch + speedRatio * 0.28,
                    Math.atan2(directionY, directionX)
                );
            });

            for (let index = splashes.length - 1; index >= 0; index -= 1) {
                const splash = splashes[index];
                const progress = splash.age / splash.life;

                splash.age += delta;
                splash.x += splash.vx * delta;
                splash.y += splash.vy * delta;
                splash.sprite.x = splash.x;
                splash.sprite.y = splash.y;
                splash.sprite.alpha = Math.max(0, 0.78 * Math.pow(1 - progress, 1.18));
                scaleSprite(
                    splash.sprite,
                    splash.radius * (1 + progress * 0.18),
                    splash.stretch,
                    splash.rotation + Math.sin(progress * Math.PI) * 0.22
                );

                if (splash.age >= splash.life) {
                    splash.sprite.destroy();
                    splashes.splice(index, 1);
                }
            }
        }

        function clearReleaseTimer() {
            window.clearTimeout(releaseTimer);
            releaseTimer = null;
        }

        function endInteraction() {
            clearReleaseTimer();
            isActive = false;
        }

        function scheduleRelease(delay) {
            clearReleaseTimer();
            releaseTimer = window.setTimeout(endInteraction, delay);
        }

        function updateTarget(event) {
            const rect = revealArea.getBoundingClientRect();

            if (!rect.width || !rect.height) return;

            const x = clamp((event.clientX - rect.left) / rect.width, 0, 1);
            const y = clamp((event.clientY - rect.top + renderBleed) / height, 0, 1);
            const dx = (x - pointer.x) * width;
            const dy = (y - pointer.y) * height;
            const speed = Math.hypot(dx, dy);

            isActive = true;
            pointer.strength = Math.max(pointer.strength, 0.72);
            pointer.px = pointer.x;
            pointer.py = pointer.y;
            pointer.vx = x - pointer.x;
            pointer.vy = y - pointer.y;
            pointer.speed = speed;
            if (speed > 4) {
                pointer.targetAngle = Math.atan2(dy, dx);
            }
            pointer.x = x;
            pointer.y = y;

            if (speed > 18) {
                addSplash(pointer.x * width, pointer.y * height, speed);
            }
        }

        if (canHover) {
            revealArea.addEventListener('pointerenter', function (event) {
                clearReleaseTimer();
                updateTarget(event);
            });

            revealArea.addEventListener('pointermove', updateTarget);
            revealArea.addEventListener('pointerleave', endInteraction);
        } else {
            revealArea.addEventListener('pointerdown', function (event) {
                clearReleaseTimer();
                updateTarget(event);
            });

            revealArea.addEventListener('pointermove', function (event) {
                if (!isActive) return;
                updateTarget(event);
            });

            revealArea.addEventListener('pointerup', function () {
                scheduleRelease(760);
            });

            revealArea.addEventListener('pointercancel', function () {
                scheduleRelease(280);
            });
        }

        app.init({
            width: 1,
            height: 1,
            backgroundAlpha: 0,
            antialias: true,
            autoDensity: true,
            resolution: Math.min(window.devicePixelRatio || 1, 1.35),
            preference: 'webgl',
            powerPreference: 'low-power'
        }).then(function () {
            const canvas = app.canvas || app.view;

            if (!canvas) return;

            canvasElement = canvas;
            canvas.className = 'gh-reimagine-pixi';
            revealArea.insertBefore(canvas, revealArea.firstChild);

            stage.addChild(paintLayer);
            app.stage.addChild(stage);
            app.ticker.maxFPS = 30;
            app.ticker.minFPS = 15;
            app.ticker.add(updateBlobPositions);
            setupCursorBlobs();
            resize();
            revealArea.classList.add('has-pixi');

            if ('ResizeObserver' in window) {
                const observer = new ResizeObserver(scheduleResize);

                observer.observe(revealArea);
            } else {
                window.addEventListener('resize', scheduleResize);
            }

            if ('IntersectionObserver' in window) {
                const observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            app.ticker.start();
                        } else {
                            app.ticker.stop();
                        }
                    });
                }, { threshold: 0.05 });

                observer.observe(revealArea);
            }

            document.addEventListener('visibilitychange', function () {
                if (document.hidden) {
                    app.ticker.stop();
                } else {
                    app.ticker.start();
                }
            });

            app.ticker.start();
        }).catch(function () {
            revealArea.classList.remove('has-pixi');
        });
    });
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
